import {postRequest} from "./helper"
export const addCityCountryApi = (data) => postRequest('admin/add-country',data);
export const listCountryStateCityApi = (data) => postRequest('admin/country-state-city-list-all',data);
//export const listCountryStateCityApi = (data) => postRequest('admin/country-state-city-list',data);
export const chnageStatusApi = (data) => postRequest('admin/change-status',data);
export const updateCountryApi = (data) => postRequest('admin/update-country',data);



// WEBPACK FOOTER //
// ./src/api/Admin/CountryCityApi.js